module.exports = __webpack_public_path__ + "assets/b8.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b8.png
// module id = 671
// module chunks = 0